enum DefaultHours {
    From = '8:00',
    To = '10:00',
    None = '-'
}

export default DefaultHours